import { render } from "./AssignSdvModal.vue?vue&type=template&id=6287520a&scoped=true"
import script from "./AssignSdvModal.js?vue&type=script&lang=js"
export * from "./AssignSdvModal.js?vue&type=script&lang=js"

import "./AssignSdvModal.vue?vue&type=style&index=0&id=6287520a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6287520a"]])

export default __exports__